<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter00" id="toc">Contents</h1>
<p class="toc">            <a class="hlink" href="#/OEBPS/frw.htm">Foreword</a></p>
<ol class="roman">
<li><p><a class="hlink" href="#/OEBPS/c01.htm">Amritsar. House of Commons. July 8, 1920</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c02.htm">Dominion Status. Written for the <em>Daily Mail</em>. November 1929</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c03.htm">The Round Table Conference. Cannon Street, City of London. December 12, 1930</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c04.htm">The Landslide. House of Commons. January 26, 1931</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c05.htm">A General View. Free Trade Hall, Manchester. January 30, 1931</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c06.htm">A Disease of the Will. Philharmonic Hall, Liverpool. March 5, 1931</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c07.htm">Conservative Differences on India. West Essex Conservative Association. February 23, 1931</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c08.htm">The Gandhi-Irwin Pact and its Consequences. House of Commons. March 12, 1931</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c09.htm">Our Duty in India. Albert Hall. March 18, 1931</a></p></li>
<li><p><a class="hlink" href="#/OEBPS/c10.htm">Towards the Deadlock. Constitutional Club. March 26, 1931</a></p></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7fd2168c